import { render, staticRenderFns } from "./ConfirmNegotiationSended.vue?vue&type=template&id=16564dc8&scoped=true&"
import script from "./ConfirmNegotiationSended.vue?vue&type=script&lang=js&"
export * from "./ConfirmNegotiationSended.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmNegotiationSended.vue?vue&type=style&index=0&id=16564dc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16564dc8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VMain})
